const AI = require('./APPLICATION_IDENTIFIERS');

/**
 *
 * @param {string} value E.g. https://example.com/01/09520123456788/10/ABC123/21/456789A?3103=000195&3922=0299&17=201225
 */
function parse(value) {
    if (!value?.startsWith('https://')) {
        throw new Error('Unsupported GS1 Digital Link URI: must start with "https://"');
    }

    //replace all  ampersands, question marks, and equal signs with slashes
    const [scheme, , hostname, ...parts] = value.replace(/\/|=|\?|&/g, '/').split('/');
    if (scheme !== 'https:' || !hostname) {
        throw new Error('Unsupported GS1 Digital Link URI: must be a valid HTTPS URL');
    }
    //for each pair of values in parts, check the first one for they key, then the second one is the value
    let result = {};
    let asString = [];
    for (let i = 0; i < parts.length; i += 2) {
        const key = parts[i];
        const value = parts[i + 1];
        if (!key || !value) {
            throw new Error(`Invalid GS1 Digital Link URI: missing key or value at index ${i}`);
        }
        //if it is a value that is mapped, include it
        if (AI[key]) {
            if (Array.isArray(AI[key])) {
                //if AI[key] is an array, iterate over the array and create a nested object for each key
                // from right to left, so the last key in the array is the most nested
                result = AI[key].reduceRight((subValue, nestedKey) => {
                    return {
                        [nestedKey]: subValue
                    };
                }, value);
            } else {
                //otherwise just set the key
                result[AI[key]] = value;
            }
            asString.push(`(${key})${value}`);
        }
    }

    if (!result.title) {
        if (result.serialNo && result['item:model']?.title) {
            //if there is no title, but there is a serialNo and item:type, set the title to the item:type
            result.title = `(01)${result['item:model'].title} (21)${result.serialNo}`;
        } else if (result.lotNo && result['item:model']?.title) {
            //if there is no title, but there is a lotNo and item:type, set the title to the item:type
            result.title = `(01)${result['item:model'].title} (10)${result.lotNo}`;
        } else if (result.serialNo) {
            //if there is no title, but there is a serialNo, set the title to the serialNo
            result.title = `(21)${result.serialNo}`;
        } else if (result['item:model']?.title) {
            //if there is no title, but there is an item:type, set the title to the item:type
            result.title = `(01)${result['item:model'].title}`;
        }
    }
    result.toString = () => asString.sort().join(' ');
    return result;
}

module.exports = {
    parse
};
